import './CompanyProfileHeader.scss';

import React, { PureComponent } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import SocialShareMenu from 'components/clickables/SocialShareMenu';
import Icon from 'components/Icon';
import Text from 'components/Text';

import cxHelpers from 'util/className';

@cxHelpers('CompanyProfileHeader')
export default class CompanyProfileHeader extends PureComponent {
  static propTypes = {
    isEditing: PropTypes.bool.isRequired,
    toggleEditing: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    submitDisabled: PropTypes.bool.isRequired,
    companyProfile: PropTypes.instanceOf(Map),
  };

  state = {
    copiedLink: false,
  };

  onCopy = () => {
    this.setState({ copiedLink: true });

    setTimeout(() => {
      this.setState({ copiedLink: false });
    }, 3000);
  };

  handleToggleEditingEdit = () => {
    this.props.toggleEditing();
  };

  handleToggleEditingCancel = () => {
    this.props.toggleEditing();
  };

  handleSubmitForm = () => {
    this.props.submitForm();
  };

  render() {
    const { isEditing, isSubmitting, submitDisabled, companyProfile } =
      this.props;

    return (
      <Box vcenter className={this.cx()}>
        <a href="/hiring/dashboard" className={this.cxEl('link')}>
          <Icon type="arrowLeft" color="white" className={this.cxEl('icon')} />
          <Text i18n="hiring.company_profile.back" />
        </a>

        <Box vcenter>
          <SocialShareMenu
            className="mrl"
            entity={companyProfile}
            placement="right"
            onCopy={this.onCopy}
            productLocation="Company Profile - Header"
            facebookLink={companyProfile.get('full_url')}
          >
            <a className={this.cxEl('link')}>
              {this.state.copiedLink ? (
                <Text i18n="actions.copied" />
              ) : (
                <Box vcenter>
                  <Icon
                    type="shareAlt"
                    color="white"
                    className={this.cxEl('icon')}
                  />
                  <Text i18n="actions.share" />
                </Box>
              )}
            </a>
          </SocialShareMenu>

          {isEditing ? (
            <div>
              <Button
                className={this.cxEl('button')}
                onClick={this.handleToggleEditingCancel}
              >
                <Text i18n="actions.cancel" />
              </Button>
              <Button
                className={this.cxEl('button')}
                theme="primary"
                onClick={this.handleSubmitForm}
                loading={isSubmitting}
                disabled={submitDisabled}
              >
                <Text i18n="actions.save" />
              </Button>
            </div>
          ) : (
            <a
              className={this.cxEl('link')}
              onClick={this.handleToggleEditingEdit}
            >
              <Icon type="edit" color="white" className={this.cxEl('icon')} />
              <Text i18n="hiring.company_profile.edit" />
            </a>
          )}
        </Box>
      </Box>
    );
  }
}
